import Vue from 'vue'
import { vSlideIn, vSafeHtml, vDebounce, vRichOverflow } from '@qxs-bns/directives'

Vue.directive('slideIn', {
  inserted: vSlideIn.mounted,
  unbind: vSlideIn.unmounted
})
Vue.directive('safeHtml', vSafeHtml)
Vue.directive('lazyImage', {
  inserted: function (el, bind) {
    let loadImg = () => {
      let bound = el.getBoundingClientRect();
      let clientHeight = window.innerHeight;
      // if(bind.value.url&&bound.top <= clientHeight){
      if (bind.value.url) {
        let source = bind.value.url;
        //加载资源
        let img = new Image()
        img.src = source
        //成功赋值到指定el上
        img.onload = () => {
          el.src = source
        }
        //失败赋值失败图片
        img.onerror = () => {
          el.src = bind.value.errorImage || require("@/assets/shop/bg_load_failed.png")
        }
        window.removeEventListener('scroll', loadImg)
      }
    }
    // 默认加载图片
    el.src = bind.value.loadImage || require('@/assets/shop/bg_normal.png')
    //初始化
    loadImg()
    //添加滚动监听
    window.addEventListener('scroll', loadImg)
  }
})
Vue.directive('richOverflow', {
  inserted: vRichOverflow.mounted,
  unbind: vRichOverflow.unmounted
})

// 积分、金额小数点;  字体大小规律：16/14 14/12 12/12，相差2px；12px最小保持一致
Vue.directive('money', function (el, bind) {
  if (!bind.value) return '-'
  let outValue = bind.value
  let del = ''
  if (outValue.indexOf('¥-') > -1) {
    outValue = outValue.replace('¥-', '¥')
    del = '-'
  }
  if (outValue.indexOf('-') === 0) {
    outValue = outValue.slice(1)
    del = '-'
  }
  let bindArr = outValue.split('-')
  let str = bindArr[0]
  let money = bindArr[0]
  let tip
  let integer
  let decimal
  let template
  if (str.indexOf('¥') > -1) {
    let arr = str.split('¥')
    tip = true
    money = arr[1]
  }

  if (money.length >= 3) {
    integer = str.substring(0, str.length - 2)
    decimal = str.substring(str.length - 2)
  } else if (money.length >= 2) {
    integer = tip ? `¥0` : `0`
    decimal = money.substring(money.length - 2)
  } else {
    integer = tip ? `¥0` : `0`
    decimal = `0${money.substring(money.length - 2)}`
  }

  if (bindArr[1]) {
    const size = parseInt(bindArr[1])
    const minSize = size >= 12 ? size - 2 : size
    template = `<span style="font-size:${size}px;">${del}${integer}</span><span style="font-size:${minSize}px;">.${decimal}</span>`
  } else {
    template = `<span>${del}${integer}</span><span>.${decimal}</span>`
  }
  el.innerHTML = template
})

/** *
  * 防抖 单位时间只触发最后一次
  *  @param {?Number|300} time - 间隔时间
  *  @param {Function} fn - 执行事件
  *  @param {?String|"click"} event - 事件类型 例："click"
  *  @param {Array} binding.value - [fn,event,time]
  *  例：<el-button v-debounce="[reset,`click`,300]">刷新</el-button>
  *  也可简写成：<el-button v-debounce="[reset]">刷新</el-button>
  *  例：<el-input v-debounce="[reset,`input`,300]"></el-button>
  */
Vue.directive('debounce', {
  inserted: vDebounce.mounted
})

// 高亮
Vue.directive('highlight', (el, binding) => {
  const { value } = binding
  if (value && typeof value === 'object') {
    const { hWord, word } = value
    let { style = 'background: yellow' } = value

    if (Object.prototype.toString.call(style) === '[object Object]') {
      const copyStyle = {}
      for (const key in style) {
        copyStyle[camelToHyphen(key)] = style[key]
      }
      style = JSON.stringify(copyStyle).replace(/{|}|"/g, '').replace(',', ';')
    }
    el.innerHTML = word.replace(new RegExp(hWord, 'ig'), a => {
      return `<span style="${style}">${a}</span>`
    })
  }
})

Vue.directive('draggable', {
  bind(el, binding) {
    let startX = 0
    let startY = 0
    let initialX = 0
    let initialY = 0
    const basePadding = binding.value || []
    let top = 0, right = 0, bottom = 0, left = 0
    if (basePadding.length === 1) {
      top = basePadding[0]
      left = basePadding[0]
      right = basePadding[0]
      bottom = basePadding[0]
    } else if (basePadding.length === 2) {
      top = basePadding[0]
      left = basePadding[1]
      right = basePadding[1]
      bottom = basePadding[0]
    } else if (basePadding.length === 3) {
      top = basePadding[0]
      left = basePadding[1]
      right = basePadding[1]
      bottom = basePadding[2]
    } else if (basePadding.length === 4) {
      top = basePadding[0]
      right = basePadding[1]
      bottom = basePadding[2]
      left = basePadding[3]
    }
    const handleStart = event => {
      startX = event.touches[0].clientX
      startY = event.touches[0].clientY
      const style = window.getComputedStyle(el)
      initialX = parseInt(style.right, 10)
      initialY = parseInt(style.bottom, 10)
      // 移除过渡效果
      el.style.transition = 'none';
    }

    const handleMove = event => {
      const moveX = event.touches[0].clientX - startX
      const moveY = event.touches[0].clientY - startY

      let newRight = initialX - moveX
      let newBottom = initialY - moveY

      // 限制元素不超出屏幕边界
      if (newRight < left) {
        newRight = left
      } else if (newRight > window.innerWidth - el.offsetWidth - right) {
        newRight = window.innerWidth - el.offsetWidth - right
      }

      if (newBottom < top) {
        newBottom = top
      } else if (newBottom > window.innerHeight - el.offsetHeight - bottom) {
        newBottom = window.innerHeight - el.offsetHeight - bottom
      }

      el.style.right = `${newRight}px`
      el.style.bottom = `${newBottom}px`
      event.preventDefault() // 阻止默认行为
    }

    const handleEnd = event => {
      const moveX = event.changedTouches[0].clientX - startX

      // 判断移动的距离并决定移动方向
      const threshold = 50; // 设置一个阈值来判断移动方向
      if (moveX > threshold) {
        // 移动到右侧
        el.style.transition = 'right 0.3s ease-out';
        el.style.right = `${window.innerWidth - el.offsetWidth - right}px`;
      } else if (moveX < -threshold) {
        // 移动到左侧
        el.style.transition = 'right 0.3s ease-out';
        el.style.right = `${left}px`;
      } else {
        // 回到原位
        el.style.transition = 'right 0.3s ease-out';
        el.style.right = `${initialX}px`;
      }

      // 触发绑定的点击事件
      if (typeof binding.value === 'function') {
        binding.value(event)
      }
    }

    el.addEventListener('touchstart', handleStart)
    el.addEventListener('touchmove', handleMove)
    el.addEventListener('touchend', handleEnd)

    el._removeEventListeners = () => {
      el.removeEventListener('touchstart', handleStart)
      el.removeEventListener('touchmove', handleMove)
      el.removeEventListener('touchend', handleEnd)
    }
  },
  unbind(el) {
    el._removeEventListeners()
  }
})
